import { CenterAlignIcon, MiddleAlignIcon } from 'canoe';
import React from 'react';

import { ValueToggle } from '@candu-ai/craft/ui';

interface Props {
  justifyContent?: string;
  flexDirection?: string;
  toggleValues: (values: Record<string, unknown>) => void;
}

export const JustifyCenter = ({ justifyContent, flexDirection, toggleValues }: Props) => {
  return (
    <ValueToggle
      toggleGroup="flex-justify"
      id="justify-center"
      data-cy="toolbox-flex-justify-center"
      onClick={() =>
        toggleValues({
          justifyContent: 'center',
        })
      }
      isActive={justifyContent === 'center'}
      icon={flexDirection === 'row' ? CenterAlignIcon : MiddleAlignIcon}
      tooltip="Center"
      color="light"
    />
  );
};
